export default class HomeLogo {
  constructor () {
    this.logos = document.querySelectorAll("[data-is-logo], .hero__logo")
    if (!this.logos.length) return

    this.bindEvents()
  }

  bindEvents () {
    window.addEventListener("scroll", () => {
      const scrollTop = window.scrollY
      this.logos.forEach((logo) => {
        logo.style.opacity = String(1 - scrollTop / 5000)
        logo.style.width = `${550 - scrollTop / 35}px`
      })
    }, { passive: true })
  }
}
